module.exports = {
	BASE_URL: "https://www.zhanggongedu.com",
};
